import {observer} from 'mobx-react-lite'
import React, {useEffect, useState} from 'react'
import {GenericStickerState} from 'yougile-model'
import {StickerItem} from '@components/sticker/sticker-item'
import {Sticker as StickerExtension} from '@extensions/sticker/sticker'
import {useAddTaskStore} from './add-task-store'
import {canCreateTask} from './can-create-task'
import {RequiredSticker} from './types'

type Props = {
  requiredSticker: RequiredSticker
  index: number
}

export const AddTaskSticker = observer((props: Props) => {
  const [state, store] = useAddTaskStore()
  const {requiredSticker} = props
  const [stickerValue, setStickerValue] = useState<GenericStickerState>()

  useEffect(() => {
    setStickerValue(requiredSticker.defaultState)
  }, [requiredSticker, requiredSticker.defaultState])

  const isRequiredSticker = requiredSticker.required === 'require'
  const stickerType = StickerExtension.getType(requiredSticker.tag)
  const isUserSticker = stickerType === 'user'
  const onPin = (value: GenericStickerState) => {
    store.changeSticker(requiredSticker.tag.id, value)
    setStickerValue(value)
  }
  const onUnpin = () => {
    store.changeSticker(requiredSticker.tag.id, undefined)
    setStickerValue(undefined)
  }
  const isError = state.isTriedCreateTask && !canCreateTask([requiredSticker])

  return (
    <StickerItem
      withMenu
      className={isUserSticker ? '!visible' : ''}
      onPin={onPin}
      onUnpin={onUnpin}
      location="task"
      hasError={isError}
      required={isRequiredSticker}
      sticker={requiredSticker.tag}
      currentValue={stickerValue}
      isAddingTask
    />
  )
})
